import { render, staticRenderFns } from "./lottery-publicity-card.vue?vue&type=template&id=89d16d7e&scoped=true&lang=pug&"
import script from "./lottery-publicity-card.vue?vue&type=script&lang=js&"
export * from "./lottery-publicity-card.vue?vue&type=script&lang=js&"
import style0 from "./lottery-publicity-card.vue?vue&type=style&index=0&id=89d16d7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d16d7e",
  null
  
)

export default component.exports